import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import VectorSource from 'ol/source/Vector';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import { EndpointsService } from './endpoints.service';
import { MapService } from './map.service';
import { ToolsControlService } from './tools-control.service';
import olMap from 'ol/Map';
import { Feature } from 'ol';
import * as olExtent from 'ol/extent';
import { Fill, Stroke, Style,Text } from 'ol/style';
import LineString from 'ol/geom/LineString';
import { fromLonLat, toLonLat } from 'ol/proj';
import { LatLonDMS } from '../models/coord-dms';
import { unByKey } from 'ol/Observable';
import { ConfigurationService } from './configuration.service';
import { CoordenateService } from './coordenate.service';
import GeoJSON from 'ol/format/GeoJSON';
import { PointsService } from './points.service';
import { NavaidModel } from '../models/navaid';
import Polygon from 'ol/geom/Polygon';
import { FeatureType } from '../models/EnumTypes';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DynamicTable } from '../popup/dynamic-table/dynamic-table.component';
import { UtilsService } from './utils.service';
import { ProjectService } from './project.service';
@Injectable({
  providedIn: 'root'
})
export class TerrainGridService {

  loading: boolean = false;
  active : boolean;
  fullScreenMode : boolean = false;
  vectorSource: VectorSource =  new VectorSource({

  });
  squareNumber:number;
  map: olMap;
  coordinates: LatLonDMS = new LatLonDMS();
  latitude : number;
  longitude : number;
  dblClickListener;
  static Color_OK = 'rgba(0,255,0,0.2)'
  static Color_Above = 'rgba(0,0,255,0.2)'
  static Color_Below = ' rgba(164,116,73.0.2)'
  constructor(
    private toolsService: ToolsControlService,
    private http : HttpClient,
    private mapService: MapService,
    private endPointService : EndpointsService,
    private rcsControl : CoordenateService,
    private pointsController : PointsService,
    private popupService : BsModalService,
    private utilsService : UtilsService,
    private configurationService : ConfigurationService,
    private projectService: ProjectService
  ) {
    let appLayer = new VectorLayerDMTR({
      source: this.vectorSource,
    });
    this.map = this.mapService.getMap('map');
    appLayer.setVisible(true);
    this.map.addLayer(appLayer);
  }

  openWindow():void {
    this.active = true;
    this.clearListeners();
    this.dblClickListener = this.map.on("dblclick", this.dblClickHandler.bind(this));
    if(this.squareNumber == null)
      this.squareNumber = 9;
  }
  switchFooter(){
    this.active = false;
    this.clearListeners();
  }
  closeFooter(){
    this.switchFooter();
    this.vectorSource.clear();
  }
  cleanMap(){
    this.vectorSource.clear();
  }
  dblClickHandler(evt) {
    if(evt.coordinate == null || this.squareNumber == null){
      return;
    }
    var clickedNavaids: Feature[] = []
    this.map.forEachFeatureAtPixel(evt.pixel,
      function(feat : Feature){
        if(feat.get('featureType') == FeatureType.Navaid){
          clickedNavaids.push(feat);
        }
      },
      {
        hitTolerance: 5
      }
    );

    const coords = toLonLat(evt.coordinate, this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857");

    if(clickedNavaids.length == 0){
     this.drawGridFromCoordinates(coords);
     return;
    }

    const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.entity = "Navaid";
    bsModalRef.content.type = "Select";
    bsModalRef.content.selectAllActive = false;
    bsModalRef.content.data = clickedNavaids;
    bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Navaids");
    bsModalRef.content.wasCanceled.subscribe(wasCanceled => {
      if (wasCanceled) {
        this.drawGridFromCoordinates(coords);
      } else {
        bsModalRef.content.onClose.subscribe(result => {
          if (result.length > 0) {
            var coords = [result[0].Longitude, result[0].Latitude];
            var navaid: NavaidModel = this.pointsController.transformFeatureInNavaid(clickedNavaids.find((feature) => feature.get('id') == result[0].id));
            this.drawGridFromCoordinates(coords, navaid);
          } else {
            this.drawGridFromCoordinates(coords);
          }
        });
      }
    });
  }
  
  createFeaturesGrid(numberOfSquaresPerLine,squareSize,bottomLeftLon,bottomLeftLat,terrainGridValues: number[][],navaidElevation?:number): Feature[]{
    var features : Feature[] = [];
    var topRightLon = bottomLeftLon + squareSize*numberOfSquaresPerLine;
    var topLeftLat  = bottomLeftLat + squareSize*numberOfSquaresPerLine;

    var centralLatIndex: number = Math.floor((this.latitude-bottomLeftLat)/squareSize);
    var centralLongIndex : number = Math.floor((this.longitude-bottomLeftLon)/squareSize);
    //draw rows
    var currentBeginCoord = [bottomLeftLon,topLeftLat];
    var currentEndCoord =  [bottomLeftLon+squareSize,topLeftLat];
    var geoJson = new GeoJSON();
    for(var i = numberOfSquaresPerLine - 1; 0 <= i + 1; i--){
      for(var j  = 0; j < numberOfSquaresPerLine; j++ ){
        var featureRowLine =  new Feature(new LineString([fromLonLat(currentBeginCoord,),fromLonLat(currentEndCoord)]));
        currentBeginCoord[0] += squareSize;
        currentEndCoord[0] += squareSize;
        if(this.rcsControl.activeRCS.isactive)
          featureRowLine.getGeometry().transform("EPSG:3857",this.rcsControl.activeRCS.epsg);
        features.push(featureRowLine);
        if(i == numberOfSquaresPerLine - 1)
          continue;
        featureRowLine.setStyle( new Style({
          fill: new Fill({
            color: 'rgba(255,255,255,0.4)'
          }),
          stroke: new Stroke({
            color: '#3399CC',
            width: 2.25
          }),
          text: new Text({
            font: '12px Calibri,sans-serif',
            stroke: new Stroke({
              color: '#fff', width: 2
            }),
            offsetX: 2,
            offsetY: -10,
            text: terrainGridValues[i+1][j].toString() + ' [m]' +
               (centralLatIndex == i+1 && centralLongIndex == j && typeof navaidElevation != 'undefined'? '\n' + navaidElevation.toString() + ' [m]': '')
          })
        }));

      }
      currentBeginCoord[0]  = bottomLeftLon;
      currentEndCoord[0] = bottomLeftLon+squareSize;
      currentBeginCoord[1] -= squareSize;
      currentEndCoord[1] -= squareSize;
    }
    //draw collumns
    var currentBeginCoord = [bottomLeftLon,topLeftLat];
    var currentEndCoord = [bottomLeftLon,bottomLeftLat];
    for(var i = 0; i < numberOfSquaresPerLine + 1; i++){
      var featureCollumnLine =  new Feature(new LineString([fromLonLat(currentBeginCoord),fromLonLat(currentEndCoord)]));
      currentBeginCoord[0] += squareSize;
      currentEndCoord[0] += squareSize;
      /*
      if(this.rcsControl.activeRCS.isactive)
        featureCollumnLine.getGeometry().transform("EPSG:3857",this.rcsControl.activeRCS.epsg);
      var featureObject = geoJson.writeFeatureObject(featureCollumnLine);
        var transformedFeature =  geoJson.readFeature(featureObject,
        {
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
        }
        )
      */
      if(this.rcsControl.activeRCS.isactive)
        featureCollumnLine.getGeometry().transform("EPSG:3857",this.rcsControl.activeRCS.epsg);
      features.push(featureCollumnLine);
    }

    return features;
  }

  async getCentralSquareColor(navaid:NavaidModel):Promise<string>{
    var terrainElevation = await (await this.pointsController.getTerrainElevation(this.latitude, this.longitude)).toPromise();
    navaid.elevationTerrainMeters = terrainElevation;
    //this.navaidController.selectedNavaid.elevationTerrainFeet = this.pointsController.convertToFeet(data);
    navaid.elevationRelativeTerrainMeters = navaid.elevationTerrainMeters + navaid.antheightMeters;
    //this.navaidController.selectedNavaid.elevationRelativeTerrainFeet = this.navaidController.selectedNavaid.elevationTerrainFeet + this.navaidController.selectedNavaid.antheight;
    if(terrainElevation > navaid.elevationRelativeTerrainMeters ){
      return TerrainGridService.Color_Below;
    }
    if(navaid.antheightMeters > this.configurationService.currentConfiguration.facilityConfiguration.aboveTerrainLimitM){
      return TerrainGridService.Color_Above;
    }
    return TerrainGridService.Color_OK;


  }
  async getCentralSquareFeature(navaid:NavaidModel,squareSize: number, bottomLeftLat: number, bottomLeftLon: number){
    var point1Lat: number = (Math.floor((this.latitude-bottomLeftLat)/squareSize))*squareSize + bottomLeftLat;
    var point1Long : number = (Math.floor((this.longitude-bottomLeftLon)/squareSize))*squareSize + bottomLeftLon;

    var point1 = fromLonLat([point1Long,point1Lat]);
    var point2 = fromLonLat([point1Long + squareSize,point1Lat]);
    var point3 = fromLonLat([point1Long + squareSize,point1Lat+ squareSize]);
    var point4 = fromLonLat([point1Long,point1Lat+ squareSize]);
    var feature: Feature = new Feature(new Polygon([[point1,point2,point3,point4,point1]]));

    if(this.rcsControl.activeRCS.isactive)
        feature.getGeometry().transform("EPSG:3857",this.rcsControl.activeRCS.epsg);
    feature.setStyle(new Style({
      fill: new Fill({
        color: await this.getCentralSquareColor(navaid),
      })
    }))
    return feature;
  }
  drawGridFromCoordinates(coords,navaid?:NavaidModel){
    this.coordinates.fromLat(coords[1]);
    this.coordinates.fromLon(coords[0]);
    this.latitude = coords[1];
    this.longitude = coords[0];
    this.drawgrid(navaid);
  }
  zoomToGrid(features:Feature[]){
    let featureExtent = olExtent.createEmpty();
    features.forEach(feature=>{
      olExtent.extend(featureExtent, feature.getGeometry().getExtent());
    });
    this.map.getView().fit(featureExtent);
  }

  drawgrid(navaid?:NavaidModel){
    this.cleanMap();
    this.loading = true;
    this.http.post(
      this.endPointService.terrainGrid,
      {centralLat: this.latitude, centralLon: this.longitude, squaresPerLine: this.squareNumber, projectId: this.projectService.activeProject.id},
      this.endPointService.httpOptions
    ).subscribe(async (data: any) => {

      
      // IMPORTANT!!!!!!!
      // data.topLeftLong and data.topLeftLat is actually the bottomLeftCorner of the Grid.
      // The backend on DEMETER Desktop returned the names wrong for some reason.

      if(typeof navaid !='undefined'){
        let  features : Feature[] = [];
        features.push(await this.getCentralSquareFeature(navaid,data.squareLineSize,data.topLeftLat,data.topLeftLong));
        features.push(...this.createFeaturesGrid(this.squareNumber,data.squareLineSize,data.topLeftLong,data.topLeftLat,data.heightsMatrix, Math.floor(+navaid.elevationMeters)));
        this.vectorSource.addFeatures(features);
        this.zoomToGrid(features);
        this.loading = false;
        return;
      }
      let  features : Feature[] = this.createFeaturesGrid(this.squareNumber,data.squareLineSize,data.topLeftLong,data.topLeftLat,data.heightsMatrix);
      this.vectorSource.addFeatures(features);
      this.zoomToGrid(features);
      this.loading = false;
      return;
    },
    ()=> {
      this.loading = false;
      return;
    })

    /*
    let feature: Feature = new Feature(new LineString([fromLonLat([8,45],'EPSG:3857'),fromLonLat([7,45],'EPSG:3857')]));
    let feature2: Feature = new Feature(new LineString([fromLonLat([8,46],'EPSG:3857'),fromLonLat([7,46],'EPSG:3857')]));
    feature.setStyle(new Style({
      geometry: new LineString([fromLonLat([8,45],'EPSG:3857'),fromLonLat([7,45],'EPSG:3857')]),
      stroke: new Stroke({
        color: 'blue',
        width: 2
    })
    }));
      /*
    */
  }
  drawGridSelectedNavaid(){
    var navaids:NavaidModel[] = this.pointsController.getSelectedNavaids();
    if(navaids.length == 0){
      return;
    }
/*
    this.coordinates.fromLat(navaid.latitude);
    this.coordinates.fromLon(navaid.longitude);
    this.latitude = navaid.latitude;
    this.longitude = navaid.longitude;
    this.drawgrid();*/
  }
  clearListeners() {
    unByKey(this.dblClickListener);
    this.map.removeEventListener("dblclick", null);
  }
  reproject(sourceProjection){
    this.vectorSource?.getFeatures().forEach(feature=>
        feature.getGeometry().transform(sourceProjection,this.map.getView().getProjection().getCode())
      );
  }
}
